import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { useTranslation } from 'react-i18next';
import { RootStackParamList } from '../types';
import { AppHeader, DeleteAccountForm, ScreenLayout, PageTitle } from '../components';
import { Colors, Spacing } from '../constants';
import { useResponsive } from '../utils/responsive';

type Props = NativeStackScreenProps<RootStackParamList, 'DeleteAccount'>;

export const DeleteAccountScreen: React.FC<Props> = ({ navigation }) => {
  const { t } = useTranslation();
  const { isDesktop } = useResponsive();

  const handleCancel = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate('Profile');
    }
  };

  return (
    <ScreenLayout maxWidth={600} desktopPadding>
      <View style={styles.container}>
        {!isDesktop && (
          <AppHeader
            navigation={{ ...navigation, goBack: handleCancel }}
            currentScreen="Profile"
            title={t('screens.deleteAccount.title')}
            showBackButton
          />
        )}
        <ScrollView contentContainerStyle={[styles.scrollContent, isDesktop && styles.scrollContentDesktop]} keyboardShouldPersistTaps="handled">
          {isDesktop && <PageTitle title={t('screens.deleteAccount.title')} onBack={handleCancel} />}
          <DeleteAccountForm onCancel={handleCancel} />
        </ScrollView>
      </View>
    </ScreenLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  scrollContent: {
    flexGrow: 1,
    padding: Spacing.base,
    paddingBottom: Spacing['3xl'],
  },
  scrollContentDesktop: {
    padding: 0,
  },
});
